export default `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0211 1.16113L12.2086 8.03613H19.0836L13.4586 12.4111L15.3336 19.2861L10.0211 14.9111L4.70862 19.2861L6.58362 12.4111L0.958618 8.03613H7.83362L10.0211 1.16113Z" stroke="currentColor" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`